import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GtmService } from './gtm.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  private CLARITY_ID = 'sqhbjicbxj';
  private GTM_ID = 'GTM-KTGSFRRT';
  private ALLOWED_ROUTES = ['/business/claim', '/business/successclaim', '/business/successupdate'];
  constructor (
    private router: Router, private clarity: GtmService
  ) {
      this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => {
        const url = e.urlAfterRedirects || e.url; // e.g. '/business/claim'
        const onAllowed = this.ALLOWED_ROUTES.some(r => url === r || url.startsWith(r + '/'));

        if (onAllowed) {
          this.clarity.enable(this.GTM_ID, this.CLARITY_ID);
        } else {
          this.clarity.disable();
        }
      });
  }
}
